App.namespace.wrap('es6.shared.collapseContent', contentBlock => {
  if (contentBlock.dataset.collapseContentInitialized === 'true') {
    return;
  }

  const defaultMaxHeight = contentBlock.clientHeight;
  const isFuzzy = contentBlock.dataset.contentCollapse === 'fuzzy';
  if (contentBlock.scrollHeight <= defaultMaxHeight) {
    return;
  }

  isFuzzy && contentBlock.classList.add('fuzzy-content');
  contentBlock.parentElement.style.position = 'relative';

  const link = document.createElement('button');
  link.classList.add('location-page-show-more')
  link.textContent = '+ Show more';
  link.style.position = 'absolute';

  link.addEventListener('click', () => {
    if (link.style.position === 'absolute') {
      contentBlock.style.maxHeight = 'none';
      isFuzzy && contentBlock.classList.remove('fuzzy-content');
      link.style.position = 'static';
      link.textContent = '- Show less';
    } else {
      contentBlock.style.maxHeight = `${defaultMaxHeight}px`;
      isFuzzy && contentBlock.classList.add('fuzzy-content');
      link.style.position = 'absolute';
      link.textContent = '+ Show more';
    }
  });

  contentBlock.parentElement.appendChild(link);

  contentBlock.dataset.collapseContentInitialized = 'true';
});
